import React, {
  useState,
} from 'react';
import ArrowLeftIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowRightIcon from '@mui/icons-material/ArrowForwardIos';
import {
  MultiMediaResponse,
} from 'dtos';
import Button from 'pages/Dashboard/components/Button';
import MediaPreview from 'pages/Dashboard/components/MediaPreview';

type Props = {
  mediaList: MultiMediaResponse[];
  isFullScreen?: boolean;
};

function Carousel({
  mediaList,
  isFullScreen = false,
}: Props) {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const media: MultiMediaResponse = mediaList[activeIndex];

  return (
    <div className="flex w-full h-full relative overflow-y-hidden">
      <MediaPreview
        media={media}
        isFullScreen={isFullScreen}
      />
      <Button
        className="!absolute top-1/2 left-1"
        variant="text"
        onClick={() => setActiveIndex((idx: number) => idx - 1)}
        disabled={activeIndex === 0}
      >
        <ArrowLeftIcon />
      </Button>
      <Button
        className="!absolute top-1/2 right-1"
        variant="text"
        onClick={() => setActiveIndex((idx: number) => idx + 1)}
        disabled={activeIndex === (mediaList.length - 1)}
      >
        <ArrowRightIcon />
      </Button>
    </div>
  );
}

export default Carousel;
